theme.givingBack = () => {
    $("#agreement-btn").on("click", function () {
      $(".vego-agreement-box-bg").removeClass("hide")
    })

    $(".vego-agreement-box-svg").click(function () {
      $(".vego-agreement-box-bg").addClass("hide")
    })
    const errroInfoObj = {
      'customer[note][agree]': 'You must agree to the agreement to continue.'
    }
    const specialCheckbox = 'organization.socialMedias'

    const feilds = [
      "fullName",
      "email",
      "phoneNumber",
      "organizationName",
      "organizationType",
      "location",
      "website",
      "socialMediaHandles",
      "projectName",
      "prejectDescription",
      "howWillUse",
      "specificNeed",
      "howWillImpactCommunity",
      "providePhotos",
      "displayVegoSign",
      "shareVegogarden",
      "vegogardenMajar",
      "writingTestimonial",
      // "doesEnvironmentalPractices",
      // "howHearAbout",
      // "additionalSahre"
    ]
    if (window.location.href.indexOf('school-gardens') > -1) { // is school-gardens
      feilds[3] = 'schoolName'
      feilds[4] = 'schoolType'
    }
    const error = "error",
      inputError = 'input-error', //input element error class
      errorInfo = 'error-info',
      errorClassPlace = 'error-class-place';
    /**
    * structure
    * |-.error-class-place(.error or .input)
    *    |- .error.info
    *    |- target: input,textarea,email directly add error info with red border, pink bg and red text
    *    |- target: radio, checkbox. warn with border and red text
    *
    */
    const itemValidator = (item, add = true) => {
      /**
       * distingiush input and radio and checkbox
       */
      let errorClassCurrent = inputError
      if (item.tagName == 'TEXTAREA' || $(item).attr('type') == 'text' || $(item).attr('type') == 'email') {
        if ($(item).closest('.' + errorInfo).find('[type="radio"],[type="checkbox"]').length) { //input & chekbox, input & radio group
          errorClassCurrent = error;
        }
      } else {
        errorClassCurrent = error;
      }


      if (add) {   // case 1: add error class

        if ($(item).hasClass(errorClassPlace)) {
          $(item).addClass(errorClassCurrent)
        } else if ($(item).closest('.' + errorClassPlace).length) {

          if ($(item).closest('[grouplabel="true"]').length) {
            let pass = false;
            /**
             * show soical input
             */
            if ($(item).closest('.vego-garden-checkbox-item-box').siblings('.vego-garden-checkbox-text-box').length) {
              $(item).closest('.vego-garden-checkbox-item-box').siblings('.vego-garden-checkbox-text-box').show()
            }
            $('[group="' + $(item).closest('[grouplabel="true"]').attr('group') + '"]').each((index, item) => {
              let satisfied = true;
              $('input', item).each((index, groupEle) => {
                if ($(groupEle).attr('type') === 'checkbox' || $(groupEle).attr('type') === 'radio') {
                  if (!$(groupEle).is(':checked')) {
                    satisfied = false
                  }
                } else {
                  if (!$(groupEle).val()) satisfied = false;
                }
              });
              if (satisfied) {
                pass = true;
              }

            })
            if (pass) return; // 有条件满足
          }


          $(item).closest('.' + errorClassPlace).addClass(errorClassCurrent)
          const errorInfoEle = $(item).closest('.' + errorClassPlace).find(`.${errorInfo}`)
          if (errorInfoEle.length) {
            errorInfoEle.html(errroInfoObj[$(item).attr('name')])
          }
        }

      } else { //case 2:  rm error class
        const componentContainer = 'input-container';

        if ($(item).hasClass(errorClassCurrent)) {                                    //Logic 1: rm error-class directly when self including error-class
          $(item).removeClass(errorClassCurrent)
        } else if ($(item).closest('.' + errorClassCurrent).length) {                 //Logic 2: rm error-class from closest div when parent including error-class

          //
          $(item).closest('.' + errorClassCurrent).removeClass(errorClassCurrent)
          const errorInfoEle = $(item).closest('.' + errorClassPlace).find(`.${errorInfo}`)


          //rm component group error
          if ($(item).closest('.' + componentContainer).length) {                     //Logic 2.1: rm group error-class when one element of is satisfied
            $(item).closest('.' + componentContainer).find('.' + errorClassCurrent).removeClass(errorClassCurrent)
          }

          if (errorInfoEle.length) {                                                 //Logic : rm error tips here due to current state of value
            errroInfoObj[$(item).attr('name')] && errorInfoEle.html('')
          }
        }
      }
    }

    const handlePeerGroup = (item) => {
      const $peerGroup = $(item).closest('[grouplabel="group"]');

      if ($peerGroup.length) {
        $('[group="' + $peerGroup.attr('group') + '"]').closest('.' + error).removeClass(error)///
        $('[group="' + $peerGroup.attr('group') + '"]').closest('.' + inputError).removeClass(inputError)///
      }
    }
    //CHECK
    const checkerFn = (item) => {

      if ($(item).attr('type') === 'radio') {                                   //Logic 1: judge radio

        //
        const $item = $('[name="' + $(item).attr('name') + '"]:checked');

        const $peerInput = $('[name="' + $item.attr('name') + '[input]"]');


        //Logic 1.1: add error-class if radio not checked
        if ($item.length === 0) {
          itemValidator(item, true)
          //Logic 1.2: radio group with text input not input anything
        } else if ($peerInput.length && !$peerInput.val()) { //
          itemValidator(item, true);
          handlePeerGroup(item)

          //Logic 1.2: radio group with text input input some words
        } else if ($peerInput.length && $peerInput.val()) {
          itemValidator(item, false);
          handlePeerGroup(item)
          //Logic 1.2: radio checked without input group
        } else {
          itemValidator(item, $item.length === 0)
        }
      } else if ($(item).attr('type') === 'checkbox') {                         //Logic 2: judge checkbox

        //  not checked
        if ($('[name="' + $(item).attr('name') + '"]:checked').length === 0) {  //Logic 2.1 checkbox
          itemValidator(item, true)
        } else {
          //checked
          $('[name="' + $(item).attr('name') + '"]:checked').map((i, item) => {
            let $input = $(item).closest('.' + errorClassPlace).find('input[type="text"]');
            if ($input.length) { //checkbox group
              itemValidator(item, !$input.val())
            } else { //check single
              itemValidator(item, false)
            }
          })
        }
      } else if (feilds.indexOf($(item).attr('name')) > -1) {                   //Logic 3:
        if (!$(item).val()) {
          itemValidator(item, true)
        } else {
          itemValidator(item, false)
          handlePeerGroup(item)
        }
      } else if ($(item).attr('name').indexOf('_input') > -1) { //input group  with radio or checkbox



        //group radio, checkbox
        const $radioOrCheckbox = $(item).closest('.' + errorInfo).find('[name="' + $(item).attr('name').replace('_input', '') + '"]:checked');
        //not radio , checkbox same group checked
        if (!$radioOrCheckbox.length) return;

        //radio, checkbx of same group checked
        //step1: checked radio, checkbox  and input has value

        if ($radioOrCheckbox.length && $(item).val()) { //
          itemValidator(item, false)

          //step2: other case
        } else {
          itemValidator(item, true)
        }

      }
    }
    const submitHandler = theme.utils.debounce(200, function (e) {
      e.preventDefault()
      //input textarea check
      $('input,textarea', e.target).each((index, item) => {
        checkerFn(item)
      })
      const submit = $('.' + inputError).length === 0 && $('.' + error).length === 0;
      if (!submit) {
        e.preventDefault()
        return;
      }

      let data = (theme.utils.serialize($('.vego-garden-content-form form')[0]))
      let form = new FormData(document.querySelector('.vego-garden-content-form form'))
      data = {
        "fullName": form.get('fullName'),
        "email": form.get('email'),
        "phoneNumber": form.get('phoneNumber'),
        // "organizationName": form.get('organizationName'),
        // "organizationType": form.get('organizationType'),
        "street": form.get('street'),
        "state": form.get('state'),
        "zipCode": form.get('zipCode'),
        "requestedItems": form.get('requestedItems'),
        "plantingDate": form.get('plantingDate'),
        "installationDate": form.get('installationDate'),
        "retailValue": form.get('retailValue'),
        // "website": form.get('website'),
        // "socialMediaHandles": form.get('socialMediaHandles'),
        "projectName": form.get('projectName'),
        // "prejectDescription": form.get('prejectDescription'),
        // "howWillUse": form.get('howWillUse'),
        // "specificNeed": form.get('specificNeed'),
        "howWillImpactCommunity": form.get('howWillImpactCommunity'),
        "providePhotos": form.get('providePhotos') == 'Yes' ? true : false,
        "allowFilmAndIterview": form.get('allowFilmAndIterview') == 'Yes' ? true : false,
        "displayVegoSign": form.get('displayVegoSign') == 'Yes' ? true : false,
        "shareVegogarden": form.get('shareVegogarden') == 'Yes' ? true : false,
        "vegogardenMajar": form.get('vegogardenMajar') == 'Yes' ? true : false,
        "writingTestimonial": form.get('writingTestimonial') == 'Yes' ? true : false,

        "howHearAbout": form.get('howHearAbout'),
        "additionalSahre": form.get('additionalSahre'),
      }
      let url = "https://app.vegogarden.com/giving-back/applying?accessToken=zNrUYJfa3lYgSwtEqQocT1KkkzKV0ohq"
      if (window.location.href.indexOf('school-gardens') > -1) { // is school-gardens
        data["schoolName"] = form.get('schoolName')
        data["schoolType"] = form.get('schoolType')
        url = "https://app.vegogarden.com/giving-back/applying-school?accessToken=zNrUYJfa3lYgSwtEqQocT1KkkzKV0ohq"
      } else {
        data["organizationName"] = form.get('organizationName')
        data["organizationType"] = form.get('organizationType')
        // data["doesEnvironmentalPractices"] = form.get('doesEnvironmentalPractices')
      }


      //data = { "fullName": "123", "email": "12312@3113.com", "localToHouston": "Yes", "applyType": "individual", "individual": { "receivingAddress": "12312@313.com", "socialMedias": [{ "name": "organization.socialMedias[_Instagram_checkbox]", "id": "on" }, { "name": "organization.socialMedias[_Instagram", "id": "12312@313.com" }], "howCanHelp": "12312@313.com", "howWillUse": "12312@313.com", "howManyBeds": "1", "specificNeed": "12312@313.com", "providePhotos": true } };
      $.post(url, data)
        .done(
          function (data) {
            if (data.code === 500) {
              // return alert(data.message)
              $('.giving-back-pop-up .giving-back-pop-up-tit').text(data.message)
              return $('.giving-back-pop-up').show()
            } else {
              $('.giving-back-pop-up .giving-back-pop-up-tit').text('Submitted Successfully')
              // return alert('Submitted Successfully')
              return $('.giving-back-pop-up').show()
            }
          }.bind(this)
        )

      return submit;
    })
    const formValidate = (rule = []) => {

      const $form = $('.vego-garden-content-form form');
      $form.submit((evt) => {
        evt.preventDefault()
        console.log('----')
        submitHandler(evt)
      })
    }

    resetError()
    function resetError() {
      $('.vego-garden-content-form form input[type=radio],.vego-garden-content-form form input[type=checkbox]').change(e => {
        checkerFn(e.currentTarget)
      })
      $('.vego-garden-content-form form input[type="email"],.vego-garden-content-form form input[type="text"],.vego-garden-content-form form textarea').on('input', e => {
        checkerFn(e.currentTarget)
      })

    }
    $(".vego-garden-btn").on("click", function () {
      if ($(".vego-garden-content-form").length) {
        $(".vego-garden-btn").hide()
        $(".vego-garden-content-form").removeClass("hide")
      }
    });
    // formValidate()
    $(".vego-garden-btn").on("click", function () {
      if ($(".vego-garden-content-form").length) {
        $(".vego-garden").addClass('show-giving-back-form')
        //$(".vego-garden-content-form").removeClass("hide")
      }
    });

    formValidate()


    // expand clickable area
    $(".vego-garden-content-box").on("click", ".vego-garden-input-box", function (e) {
      $(e.currentTarget).find("input[type='radio']:first-child").click()
    })
    $(".vego-garden-content-box").on("click", "input[type='radio']", function (e) {
      e.stopPropagation() //prevent popup to parent
    })
  }


theme.givingBack()